import React from 'react';
import { Button, ButtonProps, Form, Input, message } from 'antd';
import styled from 'styled-components';
import DefaultModal from '../organisms/DefaultModal';
import { validateEmail } from '../../services/util/validator';
import ButtonFull from '../atoms/ButtonFull';
import { useNavigate } from 'react-router-dom';
import forgotPasswordRepo from '../../services/repository/forgotPassword';
import { FormInstance } from 'antd/lib/form';

const Wrapper = styled.div`
  padding: 32px;
  margin-top: 32px;
`;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};



// Create a new type excluding 'form' from ButtonProps
type ButtonPropsWithoutForm = Omit<ButtonProps, 'form'>;

interface SubmitButtonProps extends ButtonPropsWithoutForm {
  form: FormInstance;
}

const SubmitButton: React.FC<React.PropsWithChildren<SubmitButtonProps>> = ({ form, children, ...rest }) => {
  const [submittable, setSubmittable] = React.useState<boolean>(false);

  // Watch all values
  const values = Form.useWatch([], form);

  React.useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  return (
    <Button type='primary' htmlType='submit' disabled={!submittable} {...rest}>
      {children}
    </Button>
  );
};

const CustomSubmitButtonProps = styled(SubmitButton)`
  width: 100%
`;

const ForgotPassword: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const requestResend = async () => {
    const response = await forgotPasswordRepo.requestResendPassword(form.getFieldValue('username')).then((response) => {
      if (response?.status === 204 || response?.status === 200) {
        message.success('Os dados para acesso da admissão digital foram reenviados para o email cadastrado.');
      }
    }).
      catch(reason => {
        message.error(reason.response.data.errors[0].message);
      });
  };

  return (
    <DefaultModal width={384} showBtnExit={false} squareWidth={'80%'}>
      <Wrapper>
        <Form {...formItemLayout} style={{ maxWidth: 600 }} requiredMark={false} layout='vertical' form={form}>
          <h3>Esqueceu a senha?</h3>

          <span>Preencha seu email abaixo para solicitar o reenvio da senha.</span>

          <Form.Item
            label='Email'
            name='username'
            style={{ marginTop: '16px' }}
            rules={[{ required: true, message: 'E-mail pessoal é obrigatório!' }, { validator: validateEmail }]}
          >
            <Input type='email' placeholder={'Digite aqui'} />
          </Form.Item>

          <Form.Item>
            <CustomSubmitButtonProps type={'primary'} onClick={() => requestResend()} form={form}>Solicitar Reenvio</CustomSubmitButtonProps>
          </Form.Item>

          <Form.Item>
            <ButtonFull onClick={() => navigate(-1)}>Voltar</ButtonFull>
          </Form.Item>
        </Form>
      </Wrapper>
    </DefaultModal>
  );
};

export default ForgotPassword;